<div class="footer-container">
  <p translate>Copyright © 2025 Scrub Valley</p>
</div>

